import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class CampusService {
  constructor(private http: HttpService) {}

  fetchFormCode() {
    return this.http.get(`${environment.SERVER_URL}/campus/formCode`);
  }

  fetchTenants() {
    return this.http.get(`${environment.SERVER_URL}/campus/tenants`);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/campus.service.ts